import {
  AdminListLegacyPersistedState,
  AdminListPersistedState,
  readAdminListLegacyState,
  readAdminListState,
} from './adminListStorage'
import {
  getDefaultPaymentFilter,
  PaymentFilterState,
} from '../pages/payment-management/paymentDateRange'
import {getRangeForMonth} from '../pages/trip-management/tripDateRange'
import {
  getDefaultUserFilter,
  UserFilterState,
} from '../pages/user-management/userDateRange'

function migrateUserLegacy(
  legacy: AdminListLegacyPersistedState
): AdminListPersistedState<UserFilterState> | null {
  const fo = legacy.filterObject
  let activeFilter = getDefaultUserFilter()
  if (fo?.month) {
    const range = getRangeForMonth(String(fo.month))
    activeFilter = {
      preset: 'thisMonth',
      date_from: range.date_from,
      date_to: range.date_to,
      label: range.label,
      all_time: false,
      profession: String(fo.profession ?? ''),
      role: (fo.role as number | null) ?? null,
    }
  } else if (fo) {
    activeFilter = {
      ...activeFilter,
      profession: String(fo.profession ?? ''),
      role: (fo.role as number | null) ?? null,
    }
  }
  return {
    page: legacy.page,
    searchQuery: legacy.searchQuery ?? '',
    activeFilter,
  }
}

function migratePaymentLegacy(
  legacy: AdminListLegacyPersistedState
): AdminListPersistedState<PaymentFilterState> | null {
  const fo = legacy.filterObject
  let activeFilter = getDefaultPaymentFilter()
  if (fo?.month) {
    const range = getRangeForMonth(String(fo.month))
    activeFilter = {
      preset: 'thisMonth',
      date_from: range.date_from,
      date_to: range.date_to,
      label: range.label,
      all_time: false,
      transaction_type: legacy.selectedType?.value ?? '',
    }
  } else if (legacy.selectedType?.value) {
    activeFilter = {
      ...activeFilter,
      transaction_type: legacy.selectedType.value,
    }
  }
  return {
    page: legacy.page,
    searchQuery: legacy.searchQuery ?? '',
    activeFilter,
  }
}

const LEGACY_MIGRATORS: Record<
  string,
  (legacy: AdminListLegacyPersistedState) => AdminListPersistedState<unknown> | null
> = {
  'user-management': migrateUserLegacy,
  'payment-management': migratePaymentLegacy,
}

/** Load list state from sessionStorage (new format or legacy migration). */
export function loadAdminListState<TFilter>(
  storageKey: string
): AdminListPersistedState<TFilter> | null {
  const saved = readAdminListState<TFilter>(storageKey)
  if (saved?.activeFilter) return saved

  const legacy = readAdminListLegacyState(storageKey)
  if (!legacy) return null

  const migrate = LEGACY_MIGRATORS[storageKey]
  if (!migrate) return null

  return migrate(legacy) as AdminListPersistedState<TFilter> | null
}
